import { AxiosResponse } from 'axios'
import { API } from '../../../common/api'
import { ignoreNotFound } from '../../../common/api/errorDisposition'
import {
  marketplaceServiceUrl,
  cloudfaasServiceUrl,
  hostRegion,
} from '../../../common/utils/constants'
import { CloudfaasFormAssessmentDetails } from '../../modules/assessementForm/reducer'
// import { Answers } from '../../modules/questionsList/reducer'

export const fetchAssessmentsList = (
  partnerId: string,
  pageNumber?: number,
  rowsPerPage = 10
) => {
  return API.get(`${cloudfaasServiceUrl}/partners/${partnerId}/assessments`, {
    params: {
      page_number: pageNumber || 1,
      rows_per_page: rowsPerPage,
    },
  })
}

export const fetchSectionsList = (partnerId: string) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessment_types/FTR/sections`
  )
}

export const createAssessment = (
  partnerId: string,
  assessmentData: CloudfaasFormAssessmentDetails
) => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments`,
    assessmentData
  )
}
export const updateAssessment = (
  partnerId: string,
  assessmentId: string,
  assessmentData: CloudfaasFormAssessmentDetails
) => {
  return API.patch(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}`,
    assessmentData
  )
}
export const fetchAssessmentById = (
  partnerId: string,
  assessmentId: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}`
  )
}
export const fetchQuestionsList = (
  partnerId: string,
  sectionId: string,
  assessmentId: string
) => {
  return API.get(
    `${cloudfaasServiceUrl}/partners/${partnerId}/assessments/${assessmentId}/sections/${sectionId}/questions`
  )
}

export const fetchAccounts = (partnerId: string) => {
  return API.get(`${cloudfaasServiceUrl}/partners/${partnerId}/aws_accounts`, {
    classifyError: ignoreNotFound,
  })
}

export const addAccount = (
  partnerId: string,
  data: { aws_account_id: string; role: string; account_name?: string }
) => {
  return API.post(
    `${cloudfaasServiceUrl}/partners/${partnerId}/aws_accounts`,
    data
  )
}

export const deleteAccount = (
  partnerId: string,
  labra_aws_account_id: string
) => {
  return API.delete(
    `${cloudfaasServiceUrl}/partners/${partnerId}/aws_accounts/${labra_aws_account_id}`
  )
}

export const updateAccount = (
  partnerId: string,
  awsId: string,
  data: { aws_account_id: string; role: string; account_name?: string }
) => {
  return API.patch(
    `${cloudfaasServiceUrl}/partners/${partnerId}/aws_accounts/${awsId}`,
    data
  )
}
export const fetchWorkload = (
  partnerId: string,
  hostedRegion?: string,
  workloadName?: string,
  reviewOwner?: string,
  rowsPersize = 10,
  pageNumber = 1
) => {
  return API.get(`${cloudfaasServiceUrl}/partners/${partnerId}/workload`, {
    params: {
      hosted_region: hostedRegion || hostRegion,
      rows_per_size: rowsPersize,
      page_number: pageNumber,
      ...(workloadName && { workload_name: workloadName }),
      ...(reviewOwner && { review_owner: reviewOwner }),
    },
  })
}

export const addSeller = (data: {
  partner_id: string
  seller_email?: string
  seller_name?: string
}) => {
  return API.post(`${cloudfaasServiceUrl}/partners/`, data)
}
export const updateSeller = (
  partnerId: string,
  data: { seller_email?: string; seller_name?: string }
) => {
  return API.patch(`${cloudfaasServiceUrl}/partners/${partnerId}`, data)
}
